import {mapActions} from 'vuex';

export default {
    watch: {
        errors: {
            handler: function (errorBag) {
                // console.log('errorBag', errorBag);
                // console.log('this.errors.any() ', this.errors.any());

                this.addCheckoutErrors(this.errors.any());
            },
            deep: true
        }
    },
    methods: {
        ...mapActions('checkout', [
            'addCheckoutErrors'
        ])
    }
}
